import { ttiPolyfill } from './tti-polyfill';
import { log } from '../../utils/log';
/**
 * Collects Time-to-Interactive metric.
 */
export function tti() {
    return function (ctx) {
        if (!('Promise' in window)) {
            log.error('Promise API is not supported. Time-to-Interactive metric will not be collected.');
            return;
        }
        try {
            ttiPolyfill().getFirstConsistentlyInteractive().then(function (tti) {
                if (typeof tti === 'number') {
                    ctx.track({
                        eventTypeId: 'time.to.interactive',
                        value: tti,
                    });
                }
            }).catch(function () { });
        }
        catch (e) {
            log.error('Failed to collect Time-to-Interactive metric. ' + e);
        }
    };
}
